<template>
  <div>
    <b-row>
      <b-col md="12">
        <span class="text-main-color f-size-16 font-weight-bold mb-1"
          >Images</span
        >
      </b-col>
      <b-col md="12">
        <ImageListUpload
          class="mt-1"
          v-bind:dataList="response.content.Image"
          :v="v.content.Image"
          :languageActiveId="languageActiveId"
          :sameReplyAsNeutral="sameReplyAsNeutral"
          @handleChangeImageList="handleChangeImageList"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import InputTextArea from "@/components/inputs/InputTextArea";
import ImageListUpload from "@/views/pages/flow-builder/components/sidebar/ImageListUpload";
export default {
  components: {
    InputTextArea,
    ImageListUpload,
  },
  props: {
    response: {
      required: true,
      type: Object,
    },
    v: {
      required: false,
      type: Object,
    },
    languageActiveId: {
      required: false,
      type: Number,
    },
    sameReplyAsNeutral: {
      required: false,
      type: Boolean,
    },
  },
  methods: {
    handleChangeImageList(imageList) {
      this.response.content.Image = imageList;
    },
  },
};
</script>

<style lang="scss" scoped></style>
